<template>
    <div class="header flex-box">
        <div class="left flex-box">
            <div class="font-left">{{data.Fname}}</div>
            <div class="font-right">
                <p>{{data.Ename}}</p>
                <p>{{data.Cname}}</p>
            </div>
        </div>
        <div class="right">
            <router-link :to="data.url">MORE ></router-link>
        </div>
    </div>
</template>
<script>
export default {
    props:[
        'data'
    ],
    data(){
        return{}
    }
}
</script>
<style lang="scss" scoped>
    .header{
        font-size: 0.12rem;
        background: $color-blue;
        margin: 10px 0;
        padding: 15px;
        color: #ffffff;
            .left {
                font-weight: 800;
                p { margin: 0; }
                    .font-left {
                        font-size: 45px;
                    }
                    .font-right {
                        :nth-child(1){
                            font-size: 9px;
                        }
                        :nth-child(2){
                            font-size: 20px;
                        }
                    }
            }
            .right {
                a {
                    color: #ffffff;
                    font-size: 18px;
                }
            }
    }
</style>